export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5580.53a2e43e.jpg";